import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_Twitter",
  "use": "Icon_Twitter-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" id=\"Icon_Twitter\">\n<path d=\"M5,31.05C7.905,32.913,11.356,34,15.063,34c12.188,0,19.075-10.292,18.661-19.525c1.282-0.925,2.395-2.081,3.275-3.397\n\tc-1.18,0.522-2.443,0.875-3.771,1.033c1.355-0.811,2.396-2.098,2.886-3.631c-1.269,0.751-2.673,1.298-4.167,1.593\n\tC30.75,8.798,29.044,8,27.154,8c-4.237,0-7.351,3.955-6.395,8.06c-5.457-0.274-10.293-2.886-13.531-6.858\n\tc-1.72,2.951-0.893,6.811,2.031,8.763c-1.077-0.033-2.09-0.33-2.975-0.821c-0.07,3.041,2.109,5.885,5.266,6.52\n\tc-0.925,0.252-1.937,0.309-2.964,0.111c0.833,2.608,3.259,4.504,6.132,4.559C11.961,30.496,8.483,31.462,5,31.05\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_Twitter.svg
// module id = 105
// module chunks = 0